import {
  DashboardTwoTone,
  EditFilled,
  UploadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../store/store";
import "./Home.scss";

const Home: React.FC = () => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user);

  return (
    <div className="home-container">
      <div className="home-content">
        <div className="home-header">
          <p>
            Hello, {user?.firstName} {user?.lastName}
          </p>
        </div>

        <div className="home-cards">
          <div className="card" onClick={() => navigate("/loan-application")}>
            <div className="card-icon">
              <EditFilled style={{ color: "#FD3DB5" }} />
            </div>
            <h2>Generate New Lead</h2>
            <p>Start a new loan application</p>
          </div>

          <div className="card" onClick={() => navigate("/dashboard")}>
            <div className="card-icon">
              <DashboardTwoTone />
            </div>
            <h2>Dashboard</h2>
            <p>Check your Leads</p>
          </div>

          {user?.role === "ADMIN" && (
            <>
              <div className="card" onClick={() => navigate("/images/manage")}>
                <div className="card-icon">
                  <UploadOutlined style={{ color: "#FFaF00" }} />
                </div>
                <h2>Upload Images</h2>
                <p>Manage Images</p>
              </div>
              <div className="card" onClick={() => navigate("/users")}>
                <div className="card-icon">
                  <UserOutlined style={{ color: "#ADEBB3" }} />
                </div>
                <h2>User Management</h2>
                <p>Manage system users</p>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="home-about">
        <div className="home-about-heading">About Us</div>
        <div className="home-about-description">
          D Wealth Small Finance Private Limited specializes in providing
          accessible and affordable financial solutions for micro and small
          businesses across India. We understand the challenges that small
          businesses face, from cash flow crunches to expansion requirements,
          and we are committed to supporting them with tailored loan products
          that meet their unique needs. micro loans small business finance loans
        </div>
        <div className="home-about-link-container">
          <a
            className="home-web-link"
            href="https://dwsfinance.com/"
            target="_blank"
          >
            Visit our website to learn more.
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
